"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.outreachTypes = void 0;
var outreachTypes;
(function (outreachTypes) {
    outreachTypes["EMAIL"] = "email";
    outreachTypes["SMS"] = "sms";
    outreachTypes["LETTER"] = "letter";
    outreachTypes["CALL"] = "call";
    outreachTypes["FAX"] = "fax";
    outreachTypes["PUSH_NOTIFICATION"] = "pushNotification";
    outreachTypes["PRIORITIZED"] = "prioritized";
})(outreachTypes || (exports.outreachTypes = outreachTypes = {}));
